import styled from 'styled-components';
import { Text } from '@usealloy/component-library';
import {
  NODE_TEXT_MAX_WIDTH,
  searchFocusedTextStyles,
  searchUnfocusedTextStyles,
} from '../BaseNode/BaseNode.styles';
import type { NodeState } from 'flow/service/graph';

export const SERVICE_VERSION_BADGE_WIDTH = 40;

export const StyledLabelText = styled(Text)<{
  showVersionBadge?: boolean;
  nodeState: NodeState;
}>`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: ${({ showVersionBadge }) => (showVersionBadge
    ? `calc(${NODE_TEXT_MAX_WIDTH}px - ${SERVICE_VERSION_BADGE_WIDTH}px)`
    : `${NODE_TEXT_MAX_WIDTH}px`
  )};

  ${({ nodeState }) => {
    if (nodeState === 'search-focused') return searchFocusedTextStyles;
    if (nodeState === 'search-unfocused') return searchUnfocusedTextStyles;
    return null;
  }}
`;
